<template>
  <lazy-table v-model="events" model="billing_events" :params="query">
    <div class="card-body">
      <div class="mb-4" v-for="(events, day) in grouped_events">
        <h5>{{ day }}</h5>
        <div class="row" v-for="(event, idx) in events" :class="{ 'bg-light': idx % 2 == 1 }">
          <div class="col" v-tooltip="time(event.created_at)">{{ event.body }}</div>
          <div class="col-md-3 text-right">
            <span v-if="event.record">{{ event.record.type | t }}</span>
          </div>
          <div class="col-md-3 text-right">
            <span v-if="event.record">{{ event.record.id }}</span>
          </div>
        </div>
      </div>
    </div>
  </lazy-table>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';
import moment from 'moment-es6';

export default {
  props: ['customer'],
  data: function () {
    return {
      events: [],
      query: {
        sort: '-id',
        include: 'record',
        filter: { customer_id: this.customer.id }
      }
    };
  },
  methods: {
    time(datetime) {
      return moment(datetime).format('hh:mm:ss');
    }
  },
  computed: {
    grouped_events() {
      return _.groupBy(this.events, (e) => moment(e.created_at).format('YYYY-MM-DD'));
    }
  },
  async mounted() {}
};
</script>
